<template>
  <div class="right-sidebar">
    <!-- 一级标签：待我处理 / 公海线索 -->
    <div class="sidebar-tabs">
      <!-- <span
        class="public-tab"
        :class="{ active: activeSidebar === 'pending' }"
        @click="activeSidebar = 'pending'"
      >
        待我处理({{ pendingList.length }})
      </span> -->
      <span
        class="public-tab"
        :class="{ active: activeSidebar === 'publicSea' }"
        @click="activeSidebar = 'publicSea'"
      >
        <span>
          公海线索
          <!-- 小红点，推进池有数据，则显示 -->
          <i class="circle" v-if="pageInfo.pushTotal > 0"></i>
        </span>
      </span>
      <span class="public-tab"></span>
      <span class="public-tab"></span>
      <span class="public-tab"></span>
    </div>

    <!-- 待我处理内容 -->
    <div v-if="activeSidebar === 'pending'" class="sidebar-content">
      <div
        v-for="(item, index) in sidebarData"
        :key="index"
        class="pending-card"
        @click="$emit('pendingCardClick', item)"
      >
        <div class="card-header">
          <div class="card-title">
            <span class="applicant">{{ item.applicant }}申请</span>
            <span class="apply-type">{{ item.applyType }}</span>
          </div>
          <span class="card-date">{{ item.date }}</span>
        </div>
        <div class="card-body">
          <div class="doctor-info">
            <span class="doctor-name">{{ item.doctorName }}</span>
            <CustomStarText :saleStar="item.saleStar" :avgStar="item.avgStar" />
          </div>
          <div class="doctor-data">
            <span>月销售额 {{ item.monthSale || 0 }}</span>
            <span class="divider">|</span>
            <span>次均门诊量 {{ item.avgVisitNum || 0 }}</span>
          </div>
          <div class="apply-info">
            <div class="info-row">
              <span class="info-label">线索阶段：</span>
              <span class="info-value">{{ item.stage }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">申请原因：</span>
              <span class="info-value">{{ item.reason }}</span>
            </div>
            <div v-if="item.deadline" class="info-row">
              <span class="info-label">截止时间：</span>
              <span class="info-value">{{ item.deadline }}</span>
            </div>
          </div>
        </div>
        <div class="card-footer">
          <el-button size="small" class="reject-btn" @click.stop="$emit('rejectClue', item)">拒绝</el-button>
          <el-button size="small" class="agree-btn" @click.stop="$emit('agreeClue', item)">同意</el-button>
        </div>
      </div>
    </div>

    <!-- 公海线索内容 -->
    <div v-else class="sidebar-content public-content">
      <!-- 子标签 + 查看全部 -->
      <div class="sub-tabs-bar">
        <div class="sub-tabs">
          <span
            :class="{ active: activePublicPool === 'push' }"
            @click="changePublicPoolHandle('push')"
          >推进池({{ pageInfo.pushTotal || 0 }})</span>
          <span
            :class="{ active: activePublicPool === 'incubate' }"
            @click="changePublicPoolHandle('incubate')"
          >孵化池({{ pageInfo.incubateTotal || 0 }})</span>
        </div>
        <span class="view-all" @click="$emit('viewAllClick')">查看全部 <i class="el-icon-arrow-right"></i></span>
      </div>

      <!-- 推进池列表 -->
      <div 
        v-if="activePublicPool === 'push'" 
        ref="pushListRef"
        class="pool-list"
        @scroll="scrollHandle"
      >
        <div
          v-for="(item, index) in publicPushList"
          :key="index"
          class="pool-card"
          @click="$emit('poolCardClick', item)"
        >
          <div class="pool-card-header">
            <div class="doctor-name-row">
              <span class="doctor-name">{{ item.doctorName }}</span>
              <CustomStarText :saleStar="item.saleStar" :avgStar="item.avgStar" />
            </div>
            <el-tooltip :disabled="!item.receiveClewsText" class="item" effect="dark" :content="item.receiveClewsText + '已领取'" placement="top-start">
              <span class="claim-count">已有{{ (item.clueReceiveNum || 0) }}人领取</span>
            </el-tooltip>
          </div>
          <div class="doctor-data">
            <span>月销售额 {{ item.monthSale || 0 }}</span>
            <span class="divider">|</span>
            <span>次均门诊量 {{ item.avgVisitNum || 0 }}</span>
          </div>
        </div>
        <!-- 加载状态指示器 -->
        <div v-if="pushLoading" class="loading-more">
          <i class="el-icon-loading"></i>
          <span>加载中...</span>
        </div>
        <div v-else-if="pushNoMore" class="no-more-data">
          <span>没有更多数据了</span>
        </div>
      </div>

      <!-- 孵化池列表 -->
      <div 
        v-else 
        ref="incubateListRef"
        class="pool-list"
        @scroll="scrollIncubateHandle"
      >
        <div
          v-for="(item, index) in publicIncubateList"
          :key="index"
          class="pool-card"
          @click="$emit('poolCardClick', item)"
        >
          <div class="pool-card-header">
            <div class="doctor-name-row">
              <span class="doctor-name">{{ item.doctorName }}</span>
              <CustomStarText :starText="item.star" />
            </div>
          </div>
          <div class="doctor-data">
            <span>月销售额 {{ item.monthSale || 0 }}</span>
            <span class="divider">|</span>
            <span>次均门诊量 {{ item.avgVisitNum || 0 }}</span>
          </div>
        </div>
        <!-- 加载状态指示器 -->
        <div v-if="incubateLoading" class="loading-more">
          <i class="el-icon-loading"></i>
          <span>加载中...</span>
        </div>
        <div v-else-if="incubateNoMore" class="no-more-data">
          <span>没有更多数据了</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'RightAreaContent',
  data() {
    return {
      activeSidebar: 'publicSea',
      activePublicPool: 'push',
      pageInfo: {
        pushTotal: 0,
        incubateTotal: 0,
        pageSize: 20,
        pageNum: 1
      },
      pushLoading: false,
      pushNoMore: false,
      incubateLoading: false,
      incubateNoMore: false,
      pendingList: [],
      publicPushList: [],
      publicIncubateList: []
    }
  },
  computed: {
    sidebarData() {
      return this.activeSidebar === 'pending' ? this.pendingList : []
    }
  },
  methods: {
    // 切换公海 tab
    changePublicPoolHandle(tab) {
      this.activePublicPool = tab
      // 重置分页和加载状态
      this.pageInfo.pageNum = 1
      this.pushLoading = false
      this.pushNoMore = false
      this.incubateLoading = false
      this.incubateNoMore = false
      this.getPublicSeaClueList()
    },

    // 获取公海列表数据
    async getPublicSeaClueList(isLoadMore = false, type) {
      // 是否停止跟进
      const stopTrace = type ? type !== 'push' : (this.activePublicPool === 'push' ? false : true)
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        stopTrace
      }
      try {
        if (isLoadMore) {
          if (stopTrace) {
            this.incubateLoading = true
          } else {
            this.pushLoading = true
          }
        }
        const res = await request.post('/cluepool/pc/clue/publicList', params, '')
        if (res.code === 200) {
          const newData = (res.data.data || []).map(item => ({
            ...item,
            isPublicSea: true,
            receiveClewsText: item.receiveClews && item.receiveClews.length > 0 ? item.receiveClews.map(ite => ite.workName || '').join('、') : ''
          }))
          
          if (!stopTrace) {
            // 推进池
            if (isLoadMore) {
              this.publicPushList = [...this.publicPushList, ...newData]
            } else {
              this.publicPushList = newData
            }
            this.pageInfo.pushTotal = res.data.totalElements || 0
            this.pushNoMore = this.publicPushList.length >= this.pageInfo.pushTotal
          } else {
            // 孵化池
            if (isLoadMore) {
              this.publicIncubateList = [...this.publicIncubateList, ...newData]
            } else {
              this.publicIncubateList = newData
            }
            this.pageInfo.incubateTotal = res.data.totalElements || 0
            this.incubateNoMore = this.publicIncubateList.length >= this.pageInfo.incubateTotal
          }
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('获取公海列表请求失败', error)
      } finally {
        this.incubateLoading = false
        this.pushLoading = false
      }
    },

    // 加载更多推进池数据
    loadMorePublicPush() {
      if (this.pushLoading || this.pushNoMore) return
      this.pageInfo.pageNum++
      this.getPublicSeaClueList(true)
    },

    // 加载更多孵化池数据
    loadMorePublicIncubate() {
      if (this.incubateLoading || this.incubateNoMore) return
      this.pageInfo.pageNum++
      this.getPublicSeaClueList(true)
    },

    // 处理推进池滚动事件
    scrollHandle(event) {
      const container = event.target
      const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight
      if (scrollBottom < 100 && !this.pushLoading && !this.pushNoMore) {
        this.loadMorePublicPush()
      }
    },

    // 处理孵化池滚动事件
    scrollIncubateHandle(event) {
      const container = event.target
      const scrollBottom = container.scrollHeight - container.scrollTop - container.clientHeight
      if (scrollBottom < 100 && !this.incubateLoading && !this.incubateNoMore) {
        this.loadMorePublicIncubate()
      }
    }
  },
  mounted() {
    this.getPublicSeaClueList(false, 'push')
    this.getPublicSeaClueList(false, 'incubate')
  },
  components: {
    CustomStarText: () => import('@/views/DoctorVisitLTC/components/customStarText/CustomStarText.vue')
  }
}
</script>

<style scoped lang="less">
// 右侧待处理
.right-sidebar {
  width: 340px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 4px;

  .sidebar-tabs {
    display: flex;
    border-bottom: 1px solid #E8E8E8;

    span.public-tab {
      flex: 1;
      text-align: center;
      padding: 14px 0;
      font-size: 14px;
      color: #667182;
      cursor: pointer;
      position: relative;

      &.active {
        color: #1F2329;
        font-weight: 600;

        &::after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 40px;
          height: 3px;
          background-color: #1890FF;
          border-radius: 2px;
        }
      }

      &:hover {
        color: #1890FF;
      }

      span {
        position: relative;

        .circle {
          position: absolute;
          top: 1px;
          right: -4px;
          width: 6px;
          height: 6px;
          background-color: #FF1D21;
          border-radius: 50%;
        }
      }
    }
  }

  .sidebar-content {
    .pending-card {
      border: 1px solid #E8E8E8;
      border-radius: 4px;
      padding: 16px;
      margin-bottom: 12px;
      cursor: pointer;

      &:last-child {
        margin-bottom: 0;
      }

      &:hover {
        box-shadow: 0px 4px 12px 0px rgba(0,20,42,0.15);
        border: 1px solid #1890FF;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;

        .card-title {
          display: flex;
          align-items: center;
          gap: 8px;

          .applicant {
            font-size: 14px;
            color: #1F2329;
            font-weight: 500;
          }

          .apply-type {
            font-size: 13px;
            color: #1890FF;
          }
        }

        .card-date {
          font-size: 13px;
          color: #9AA0A8;
        }
      }

      .card-body {
        .doctor-info {
          display: flex;
          align-items: center;
          gap: 8px;
          margin-bottom: 8px;

          .doctor-name {
            font-size: 15px;
            font-weight: 600;
            color: #1F2329;
          }
        }

        .doctor-data {
          font-size: 13px;
          color: #667182;
          margin-bottom: 12px;

          .divider {
            margin: 0 8px;
            color: #D3D3D5;
          }
        }

        .apply-info {
          .info-row {
            font-size: 13px;
            line-height: 20px;
            color: #667182;

            .info-label {
              color: #9AA0A8;
            }

            .info-value {
              color: #667182;
            }
          }
        }
      }

      .card-footer {
        display: flex;
        justify-content: flex-end;
        gap: 8px;
        margin-top: 12px;

        .reject-btn {
          border-color: #D3D3D5;
          color: #667182;
        }

        .agree-btn {
          color: #1890FF;
          border-color: #1890FF;
        }
      }
    }

    // 公海线索内容
    &.public-content {
      padding-top: 12px;

      .sub-tabs-bar {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        padding: 0 10px;

        .sub-tabs {
          display: flex;
          background-color: #F7F8F9;
          border-radius: 4px;
          overflow: hidden;

          span {
            padding: 6px 12px;
            font-size: 13px;
            color: #667182;
            cursor: pointer;
            transition: all 0.2s;

            &.active {
              background-color: #1890FF;
              color: #fff;
              font-weight: 500;
            }

            &:hover:not(.active) {
              color: #1890FF;
            }
          }
        }

        .view-all {
          font-size: 13px;
          color: #667182;
          cursor: pointer;

          &:hover {
            color: #1890FF;
          }
        }
      }

      .pool-list {
        padding: 0 12px;
        height: calc(100vh - 200px);
        overflow-y: auto;

        .pool-card {
          border: 1px solid #E8E8E8;
          border-radius: 4px;
          padding: 12px;
          margin-bottom: 12px;
          cursor: pointer;

          &:hover {
            box-shadow: 0px 4px 12px 0px rgba(0,20,42,0.15);
            border: 1px solid #1890FF;
          }

          &:last-child {
            margin-bottom: 0;
          }

          .pool-card-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 8px;

            .doctor-name-row {
              display: flex;
              align-items: center;
              gap: 8px;

              .doctor-name {
                font-size: 15px;
                font-weight: 600;
                color: #1F2329;
              }
            }

            .claim-count {
              font-size: 13px;
              color: #29C01B;
              flex-shrink: 0;
              cursor: pointer;
            }
          }

          .doctor-data {
            font-size: 13px;
            color: #667182;
            margin-bottom: 10px;

            .divider {
              margin: 0 8px;
              color: #D3D3D5;
            }
          }
        }

        // 加载更多状态
        .loading-more,
        .no-more-data {
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 16px 0;
          font-size: 13px;
          color: #9AA0A8;

          i {
            margin-right: 6px;
          }
        }

        .no-more-data {
          color: #C0C4CC;
        }
      }
    }
  }
}
</style>
